export const SET_ACTIVE_DESK_CARD = "SET_ACTIVE_DESK_CARD";
export const PICK_CARD = "PICK_CARD";
export const RESET_CARDS = "RESET_CARDS";

export const RANDOMIZE_BOARD = "RANDOMIZE_BOARD";
export const CLEAR_BOARD = "CLEAR_BOARD";

export const TOGGLE_SQUARE = "TOGGLE_SQUARE";
export const CLEAR_STARTING_HAND_BOARD = "CLEAR_STARTING_HAND_BOARD";

export const SET_ACTIVE_COLOR = "SET_ACTIVE_COLOR";
export const CHANGE_COLOR = "CHANGE_COLOR";